import GroupTitle from "./GroupTitle";


type Props={
    isShortView?:boolean,
    paymentDesc: string
}
const FirmDescriptionArea = (props:Props) => {

 const { paymentDesc, isShortView} = props;


    if (!paymentDesc) {
        return null;
    }
    return (
        <div className=" mt-6">
            {!isShortView&&(
                  <GroupTitle title="Ödeme Notları" />
            )}
          
            <div  className={`mt-4  ${isShortView ?"max-h-[160px]":"max-h-[350px]"} overflow-auto px-6 py-4 shadow-lg scrollbar-thin`}
            dangerouslySetInnerHTML={{
                __html:paymentDesc
            }}
            >
                

            </div>
        </div>
    );
}
export default FirmDescriptionArea;


 